import PropTypes from 'prop-types';
import { useMemo } from 'react';
import moment from 'moment';
import { DateTimeComponent } from '../../../../../components/mobileForm/componentsMobileForm/DateTimeComponent';
import { DateComponent } from '../../../../../components/mobileForm/componentsMobileForm/DateComponent';

export const EditDateTime = ({ value, onChange }) => {
  const format = 'MMM D, YYYY h:mm A';
  const currentValue = useMemo(() => {
    return moment(value, format).toDate();
  }, [value]);

  const onChangeValue = (newValue) => {
    onChange(moment(newValue).locale('en').format(format));
  };

  return <DateTimeComponent value={currentValue} onChange={onChangeValue} />;
};

export const EditDate = ({ value, onChange }) => {
  const format = 'MMM D, YYYY';
  const currentValue = useMemo(() => {
    return moment(value, format).toDate();
  }, [value]);

  const onChangeValue = (newValue) => {
    onChange(moment(newValue).locale('en').format(format));
  };

  return <DateComponent value={currentValue} onChange={onChangeValue} />;
};
EditDateTime.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

EditDate.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};
